import { withAuthenticationRequired, useAuth0 } from "@auth0/auth0-react";
import { Component, ComponentType, useEffect, useState } from "react";
import { Navigate, Route, useNavigate } from "react-router-dom";
import { warrantService } from "../../api/services/warrant.service";



export const WarrantGuard = ({ component: Component, ...rest }: { component: ComponentType<any>,  [key: string]: any }) => {

    const [hasAcceptedAgreement, setHasAcceptedAgreement] = useState<boolean | null>(null);


    useEffect(() => {
        console.log("WarrantGuard: calling isCurrentUserAcceptedTerms");
        warrantService
            .isCurrentUserAcceptedTerms()
            .then((acceptedTerms) => {
                console.log("WarrantGuard: acceptedTerms:", acceptedTerms);
                setHasAcceptedAgreement(acceptedTerms);
            })
            .catch((error: any) => {
                console.error("Error checking access:", error);
                setHasAcceptedAgreement(false);
            });

    }, []);

    // While waiting for the backend response, you can render a loading indicator
    if (hasAcceptedAgreement === null) {
        return <div>Loading...</div>;
    }


    // If the check passes, render the child components
    return (
        hasAcceptedAgreement === true
            ? <Component />
            : <Navigate to='/terms-and-conditions' />
    );
};



